module.exports = __webpack_public_path__ + "img/beex-dark-medium.cb907505.svg";